<sbnb-nested-full-screen-modal (backIconClicked)="close()">
  <ng-container ngProjectAs="content">
    <header class="mb-6 w-full">
      <h2 class="mb-2">
        @if (dialogData.mode === RuleSetDialogMode.APPLY) {
          Apply rule-set
        } @else {
          Manage rule-sets
        }
      </h2>
      <span class="text-night leading-6">
        @if (dialogData.mode === RuleSetDialogMode.APPLY) {
          Create a new one or reuse a saved rule-set.
        } @else {
          View, edit, and organize your pricing rule sets.
        }
      </span>
    </header>

    @if (error()) {
      <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
    } @else if (loading()) {
      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
    } @else {
      @if (rulesets()?.length) {
        <sbnb-button
          class="block mb-6"
          [fullWidth]="true"
          label="Create new rule-set"
          type="secondary"
          (click)="createNewRuleset()"></sbnb-button>

        <!-- Search -->
        <sbnb-form-label label="Search rule-sets"></sbnb-form-label>
        <sbnb-search-bar
          class="block mt-2 mb-4"
          [placeholderText]="'Search rule-sets...'"
          [size]="'default'"
          (searchChanged)="searchCriteria.set($event)"></sbnb-search-bar>

        @if (filteredRulesets()?.length === 0) {
          <div class="flex flex-col gap-2">No rule-sets found matching this criteria</div>
        }

        @for (ruleset of filteredRulesets(); track ruleset.id) {
          <div
            class="border rounded-md p-3 mb-3 flex flex-col gap-3"
            *ngIf="deleteLoaders[ruleset.id] !== DELETE_LOADING_STATES.DELETED"
            [ngClass]="{ 'cursor-pointer hover:bg-smoke-lighter': dialogData.mode === RuleSetDialogMode.APPLY}"
            (click)="dialogData.mode === RuleSetDialogMode.MANAGE ? null : selectRuleset(ruleset)">
            <div class="flex justify-between gap-2">
              <h4 class="text-sm">{{ ruleset.title }}</h4>
              <div
                class="w-6 h-6 rounded-full border flex-shrink-0 border-smoke"
                [class]="'bg-ruleset-' + ruleset.color"></div>
            </div>
            <div class="text-sm text-night line-clamp-2">
              {{ ruleset.summary }}
            </div>
            <div
              *ngIf="isCS && (debugMode$ | async)"
              class="flex flex-row justify-end w-full pt-2 pb-1"
              (click)="$event.stopPropagation()">
              <sbnb-cs-debug-item
                class="text-sm"
                label="id"
                [coreNovaLink]="'/resources/calendar-rulesets/' + ruleset.id"
                linkLabel="Nova"
                [value]="ruleset.id.toString()" />
            </div>
            @if (dialogData.mode === RuleSetDialogMode.MANAGE) {
              <div class="flex gap-4">
                <u
                  class="text-night font-bold cursor-pointer text-sm mr-1"
                  (click)="$event.stopPropagation(); editRuleset(ruleset.id)"
                  >Edit
                </u>
                <u
                  class="text-error-500 font-bold cursor-pointer text-sm delete-cta"
                  [ngClass]="{ disabled: deleteLoaders[ruleset.id] === DELETE_LOADING_STATES.LOADING }"
                  (click)="$event.stopPropagation(); deleteRuleset(ruleset)">
                  Delete
                </u>

                <ui-loading-spinner
                  *ngIf="deleteLoaders[ruleset.id] === DELETE_LOADING_STATES.LOADING"
                  [size]="16"
                  [muted]="true"></ui-loading-spinner>
              </div>
            }
          </div>
        }
      } @else {
        <sbnb-button
          class="block mb-6"
          [fullWidth]="true"
          label="Create new rule-set"
          type="secondary"
          (click)="createNewRuleset()"></sbnb-button>
        <div class="flex flex-col gap-2">
          <span>No rule-sets found</span>
        </div>
      }
    }
  </ng-container>
</sbnb-nested-full-screen-modal>

<ng-template #errorTemplate>
  <!-- TODO: -->
  ERROR...
</ng-template>

<ng-template #loadingTemplate>
  <div class="animate-pulse">
    <!-- Button Skeleton -->
    <div class="h-10 w-full bg-smoke rounded mb-6"></div>

    <!-- Label Skeleton -->
    <div class="h-4 w-1/3 bg-smoke rounded mb-2"></div>
    <!-- Search Bar Skeleton -->
    <div class="h-10 w-full bg-smoke rounded mt-2 mb-4"></div>

    <!-- Ruleset Skeletons (Repeat 5 times) -->
    @for (_ of [1, 2, 3, 4, 5]; track _) {
      <div class="border border-smoke rounded-md p-3 mb-3">
        <div class="flex flex-col gap-2">
          <div class="h-6 w-3/4 bg-smoke rounded"></div>
          <div class="h-4 w-1/2 bg-smoke rounded"></div>
        </div>
      </div>
    }
  </div>
</ng-template>
